<template>
    <RouteLoading v-if="$store.getters.routeLoading" />
    <router-view></router-view>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  getAccessToken,
  getStepRegister,
  setStepRegister,
  setVerifyPhone,
  getPushToken,
} from "@/auth";
import RouteLoading from "@/layout/components/RouteLoading";
import CONSTANTS from "@/constants";
import mixin from '@/mixin'
export default {
  mixins: [mixin],
  components: {
    RouteLoading,
  },
  name: "App",
  async mounted() {
    if (!this.defaultToken) {
      await this.getDefaultToken({
        len: 32,
      });
    }
    if (parseInt(getStepRegister()) === CONSTANTS.STEP_REGISTER_UPDATE_INFO) {
      this.$router.push({
        name: "register",
      });
    }
    const hasAccessToken = getAccessToken();
    if (!this.metadata) {
      await this.getMetadata();
    }
    if (hasAccessToken) {
      if (!this.userDetail) {
        await this.userProfile({
          token: this.defaultToken,
        });
      }
      if (!this.profileTemplate) {
        await this.getProfileTemplate({
          token: this.defaultToken,
        });
      }
      await this.initSocket();
      this.listenerEventSocket();
      await this.$store.dispatch("socket/setupSocketCallEvent");
      if (!getPushToken()) {
        await this.getTokenFirebase()
      }
    }
    if (!getStepRegister()) {
      setStepRegister(CONSTANTS.STEP_REGISTER_INFO);
    }
    if (
      this.userDetail &&
      parseInt(this.userDetail.is_verify_phone) !==
        CONSTANTS.VERIFY_PHONE_NUMBER_SUCCESS
    ) {
      setStepRegister(CONSTANTS.STEP_REGISTER_UPDATE_INFO);
      setVerifyPhone(0);
      await this.$router.push({
        name: "register",
      });
    }
    if (
      this.userDetail &&
      parseInt(this.userDetail.is_verify_phone) ===
        CONSTANTS.VERIFY_PHONE_NUMBER_SUCCESS &&
      parseInt(getStepRegister() === CONSTANTS.STEP_REGISTER_DONE)
    ) {
      window.localStorage.removeItem("step_register");
      setVerifyPhone();
    }
  },
  computed: {
    ...mapGetters([
      "defaultToken",
      "userDetail",
      "messages",
      "pointSetting",
      "profileTemplate",
      "metadata",
    ]),
  },


  methods: {
    ...mapActions({
      getMetadata: "metadata/getMetadata",
      initSocket: "socket/initState",
      getDefaultToken: "user/getDefaultToken",
      userProfile: "user/userProfile",
      getProfileTemplate: "profile/getProfileTemplate",
    }),
    listenerEventSocket() {
      this.sockets.subscribe("server-chat-send-ok", async (data) => {
        if (data.u_id == this.$store.getters.userDetail.id) {
          if (data.type === "image") {
            await this.$store
              .dispatch("message/getMedia", {
                id: data.param.media_id,
                token: this.defaultToken,
                size: "medium",
                thumbnail: true,
              })
              .then((res) => {
                // console.log(res.path)
                data.path = res.path;
              })
              .catch((err) => {
                // rej(err)
              });
          }
          await this.$store.dispatch("message/updateMessage", data);
          window.scrollTo(
            0,
            document.body.scrollHeight || document.documentElement.scrollHeight
          );
        }
      });
      this.sockets.subscribe("server-chat-receive", async (data) => {
        if (data.r_id == this.$store.getters.userDetail.id) {
          if (data.type === "image") {
            await this.$store
              .dispatch("message/getMedia", {
                id: data.param.media_id,
                token: this.defaultToken,
                size: "medium",
                thumbnail: true,
              })
              .then((res) => {
                data.path = res.path;
              })
              .catch((err) => {
                // rej(err)
              });
          }
          await this.$store.dispatch("message/updateMessage", data);
          // window.scrollTo(
          //   0,
          //   document.body.scrollHeight || document.documentElement.scrollHeight
          // );
        }
      });
      this.sockets.subscribe("server-chat-message-typing", (data) => {});
      this.sockets.subscribe("server-message-is-read", (data) => {});
    },
  },
};
</script>

<style scoped>
@import "~@/styles/index.css";
</style>
<style>

.loading-screen {
  background: #fff;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
header,
footer,
.h-menu,
.h-menu2,
.h-menu3 {
  z-index: 99999;
}
.loader {
  display: inline-block;
  margin: 5px 0;
  width: 28px;
  height: 28px;
  font-size: 28px;
  line-height: 28px;
  border-radius: 50%;
  border: 2px solid #777;
  border-right-color: transparent;
  -webkit-animation: spin 1s linear infinite; /* Safari */
  animation: spin 1s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>